module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"New Newsletter Subscription Topic":"Neues Abonnement-Thema","Show filters":"Filter anzeigen","Hide filters":"Filter verbergen","Newsletter Subscription Topic list could not be fetched.":"Abonnement-Thema Liste konnte nicht abgerufen werden."}}')
  delete Component.options._Ctor
}
